import '../App.css';
import '../styles/aboutSection.css'
import 'react-responsive-modal/styles.css';

import keyPeople from '../data/keyPeople.json';
import { KeyPerson } from '../types'
interface props {
    refProp: any,
}

function AboutUs({refProp}: props) {
    return (
        <div className='about-section' ref={refProp} id='about-us'>
            <div className='about-section-left'>
                <h1 className='section-title'>About Us</h1>
                <div className='about-us'>
                    <p className='text-large bold'>Labour in the City is a social group for Labour members and supporters who work in financial and related professional services in the UK. We have members across the country and in an array of different jobs, from front line bank staff to lawyers and accountants.</p>
                    <p className='text-medium'>We have members from across London and the UK in every major financial and professional sector, and are a good place to meet people with similar politics convictions, and to become more involved in politics.</p>
                    <p className='text-medium'>We regularly organise events with Labour speakers, and as a member-led organisation, we welcome proposals from members who would like to take forward any ideas for events and activity themselves.</p>
                </div>
            </div>
            <div className='about-section-right'>
                <div className='key-people'>
                    <div className='key-people-top'>
                        <p className='key-people-title'>Key People</p>
                    </div>
                    <div className='key-people-cards'>
                        {keyPeople.map((person: KeyPerson, key: number) => {
                            return (
                                <div className='key-person-card' key={key}>
                                    <img src={require(`../assets/${person.picture}`)} alt="" className='key-person-img'></img>
                                    <p className='key-person-name'>{person.name}</p>
                                    <p className='key-person-role'>{person.role}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
